import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './Authform.css';
import { useNavigate } from 'react-router-dom';
import axios from '../axios';
import logoss from '../assets/img/naturalofficelogo.png';
import UIContext from '../components/Context.js/UIContext';
function AuthForm({ }) {
  const navigate = useNavigate();
  const [username, setusername] = useState('');
  const [password, setpassword] = useState('');
  const [open, setopen] = useState(false);

  const { showLoader, hideLoader, openSnackBar } = useContext(UIContext);


  const Getdashboarddata = async (CustomerId) => {
    try {
      showLoader();
      const getdash = await axios.instance.get(`Dashboard/Cus/${CustomerId}`
        // , {
        //   headers: { Authorization: token, 'Content-Type': 'application/json' },
        // }
      );
      for (const data of getdash.data) {
        sessionStorage.setItem('Companyid', data.Company_Id);
        sessionStorage.setItem('CompanyName', data.Company_Name)
        sessionStorage.setItem('StateId', data.StateId);
        sessionStorage.setItem('Statename', data.State);
        sessionStorage.setItem('StateCode', data.StateCode);
        sessionStorage.setItem('CompanyStateCode', data.CompanyStateCode);
        sessionStorage.setItem('CompanyStateId', data.CompanyStateId);
      }
    } catch (error) {
      openSnackBar('Something went wrong', 'error');
      console.error(error);
    }
    finally {
      hideLoader();
    }
  };

  const login = async e => {
    e.preventDefault();
    try {
      showLoader();
      const res = await axios.instance
        .post('/login', {
          User_Code: username,
          Password: password,
        });

      await Getdashboarddata(res.data.getlogin[0].Customer_Log);
      if (Object.keys(res.data).length === 2) {
        sessionStorage.setItem('user', JSON.stringify(res.data));
        sessionStorage.setItem('authtoken', 'Bearer ' + res.data.token);
        for (const data2 of res.data.getlogin) {
          sessionStorage.setItem('AuthUser', 'true');
          sessionStorage.setItem('Usercode', data2.UserCode || '');
          sessionStorage.setItem('Username', data2.UserName || '');
          sessionStorage.setItem('Userid', data2.UserId || '');
          sessionStorage.setItem('Special_User', data2.Special_User || '');
          sessionStorage.setItem('Customer_Log', data2.Customer_Log || '');
          sessionStorage.setItem('CustomerName', data2.CustomerName || '');
          sessionStorage.setItem('Branch_Log', data2.Branch_Log || '');
          sessionStorage.setItem('BranchName', data2.BranchName || '');
          sessionStorage.setItem('AdminUser', data2.AdminUser || '');
          sessionStorage.setItem('approvereq', data2.ApprovalReq || '');
          sessionStorage.setItem('CustomerHo_id', data2.CustomerHo_id || '');
          sessionStorage.setItem('CustomerHo_Name', data2.CustomerHo_Name || '');
          sessionStorage.setItem('IndentUser', data2.Indent_User || 'N')
          sessionStorage.setItem('IndentApprovalUser', data2.Indent_Approval_User || 'N')
          sessionStorage.setItem('POUser', data2.PO_User || 'N')
          sessionStorage.setItem('POApprovalUser', data2.PO_Approval_User || 'N')
          sessionStorage.setItem('AllBranch', data2.AllBranch || 'N')
          sessionStorage.setItem('Indent_Required', data2.Indent_Required || 'N')
          sessionStorage.setItem('PO_Approval_Required', data2.PO_Approval_Required || 'N')
          sessionStorage.setItem('Indent_Approval_Required', data2.Indent_Approval_Required || 'N')
          sessionStorage.setItem('IndentApproval_POApproval_Required', data2.IndentApproval_POApproval_Required || 'N')
        }
      }
      if (Object.keys(res.data).length === 2) {
        if (res.data.getlogin[0].Indent_User === 'N' && res.data.getlogin[0].Indent_Approval_User === 'N') {
          navigate('/DashboardPO');
        } else {
          navigate('/Dashboard');
        }

      } else {
        setopen(true);
      }
      setTimeout(() => {
        setopen(false);
      }, 2000);
    } catch (error) {
      openSnackBar('Something went wrong', 'error');
      console.error(error);
    }
    finally {
      hideLoader();
    }
  };
  useEffect(() => {
    sessionStorage.setItem('cateid', 0);
    sessionStorage.setItem('AuthUser', 'false');
  }, []);
  const changepss = () => {
    console.log('clicked');
    navigate('/changepassword');
  };
  return (
    <div>
      <div className="imgaesty">
        <img src={logoss} alt="imagesishd" />
        <p style={{ color: '#7b3772', textAlign: 'center' }}>
          <b>Order online for your office needs</b>
        </p>
      </div>
      <div className="authpage">
        <div className="cardlogin">
          <Form onSubmit={login}>
            <FormGroup>
              <Label>User code</Label>
              <Input
                value={username}
                placeholder="User code"
                onChange={e => setusername(e.target.value)}
              />
              {open ? <p className="errors">invalid usercode</p> : ''}
            </FormGroup>
            <FormGroup>
              <Label>Password</Label>
              <Input
                type="password"
                value={password}
                placeholder="password"
                onChange={e => setpassword(e.target.value)}
              />
              {open ? <p className="errors">invalid password </p> : ''}
            </FormGroup>
            <FormGroup>
              <div className="flex2 my-0 py-0">
                <p
                  style={{
                    color: 'red',
                  }}
                  onClick={changepss}
                >
                  Change Password
                </p>
              </div>
            </FormGroup>
            <Button className="bg-gradient-theme-left border-2" block>
              Login
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';
AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
};
AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  onLogoClick: () => { },
};
export default AuthForm;
